export const METHODOLOGY_DISCLOSURE =
  "Results are a directionally representative web-enabled AI simulation. They are not an exact replication of the ChatGPT, Claude, Gemini, or Perplexity consumer UI experiences.";
